module.exports = __webpack_public_path__ + "img/logo-header-white.4bd31e1a.png";